module.exports = __webpack_public_path__ + "img/unit.9eee1b44.png";